import BaseController from "./base_controller"

export default class extends BaseController {
  static values = {
    confirmTitle: { type: String },
    confirmMessage: { type: String },
    confirmButtonTitle: { type: String },
    cancelButtonTitle: { type: String }
  }

  connect() {
    this.confirmModal = document.querySelector('.design-system-modal-confirm-component')
    this.confirmed = false
  }

  async ask(event) {
    if (!this.confirmModal) return
    if (this.confirmed) return true

    event.preventDefault()
    event.stopImmediatePropagation()

    this.confirmed = await this.showConfirmModal()

    if (this.confirmed) {
      if (event.type == 'submit') {
        event.target.requestSubmit()
      } else if (event.type == 'click') {
        event.target.click()
      }
    }
  }

  showConfirmModal() {
    const showEvent = new CustomEvent("show", {
      detail: {
        confirmTitle: this.confirmTitleValue,
        confirmMessage: this.confirmMessageValue,
        confirmButtonTitle: this.confirmButtonTitleValue,
        cancelButtonTitle: this.cancelButtonTitleValue
      }
    })

    this.confirmModal.dispatchEvent(showEvent)

    return new Promise((resolve) => {
      this.confirmModal.addEventListener("design-system--modal-confirm-component:cancel", () => resolve(false), { once: true })
      this.confirmModal.addEventListener("design-system--modal-confirm-component:confirm", () => resolve(true), { once: true })
    })
  }
}
